/*
 * @Author: zxf
 * @Date: 2022-03-02 20:42:45
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\utils\Tiles.js
 */
import * as THREE from "../../libs/three.js/build/three.module.js";
import {Utils} from "../utils.js";
import Singleton from '../clazz/Singleton';

export class Tiles extends Singleton{
    constructor(options) {
        super(options);
        this.viewer = options.viewer;
        this.domElement = this.viewer.renderArea;
        this.scene = options.viewer.scene;
        this.tileNum = 400;
    }

    setTileNum(num) {
     this.tileNum = num;
    }

    getTileNum() {
      return this.tileNum
    }

    getTilesByBox(box) {
      const xMin = Math.floor(box.min.x / this.tileNum);
      const xMax = Math.floor(box.max.x/ this.tileNum);
      const yMin = Math.floor(box.min.y / this.tileNum);
      const yMax = Math.floor(box.max.y / this.tileNum);
      const tiles = [];
      for(let i = xMin; i <= xMax; i++) {
        for(let j = yMin; j <= yMax; j++) {
          tiles.push({ x : i, y : j });
        }
      }
      return tiles
    }

    getSceneBBoxOccupyTiles() {
      const box3 = this.viewer.getBoundingBox();
      const xMin = Math.floor(box3.min.x / this.tileNum);
      const xMax = Math.floor(box3.max.x  / this.tileNum);
      const yMin = Math.floor(box3.min.y / this.tileNum);
      const yMax = Math.floor(box3.max.y  / this.tileNum);

      const tiles = []
      for(let i = xMin; i <= xMax; i++) {
        for(let j = yMin; j <= yMax; j++) {
            tiles.push({ x : i, y : j });
        }
      }
      return tiles;
      // const helper = new Box3Helper(box3, new Color('yellow'));
      // this.viewer.scene.scene.add(helper);
    }

    getTilesByScreenBox() {
        const box = this.getScreenBox();
        const tiles = [];
        const xMin = Math.floor(box.xMin / this.tileNum);
        const xMax = Math.floor(box.xMax / this.tileNum);
        const yMin = Math.floor(box.yMin / this.tileNum);
        const yMax = Math.floor(box.yMax / this.tileNum);
        for(let i = xMin; i <= xMax; i++) {
            for(let j = yMin; j <= yMax; j++) {
                tiles.push({ x : i, y : j });
            }
        }
        return {tiles: tiles, box: box};
    }
    
    getScreenBox() {
        const width = this.domElement.clientWidth;
        const height = this.domElement.clientHeight;
        const p2 = Utils.getWorldCoordinate(this.domElement, this.scene, 0, 0);
        const p3 = Utils.getWorldCoordinate(this.domElement, this.scene, width, height);
        const p4 = Utils.getWorldCoordinate(this.domElement, this.scene, width, 0);
        const p5 = Utils.getWorldCoordinate(this.domElement, this.scene, 0, height);
        return {xMax: Math.max(p2.x,p3.x,p4.x,p5.x), xMin: Math.min(p2.x,p3.x,p4.x,p5.x), yMax: Math.max(p2.y,p3.y,p4.y,p5.y), yMin: Math.min(p2.y,p3.y,p4.y,p5.y)};
    }

    getTileByPosition(position) {
      return { x: Math.floor(position.x / this.tileNum), y: Math.floor(position.y / this.tileNum) };
    }
    
    getTileByPoint(mouse) {
        const p2 = Utils.getWorldCoordinate(this.domElement, this.scene, mouse.x, mouse.y);
        // const defect = SceneRegister.getInstance().scenes['defect'];
        // const geometry = new BufferGeometry();
        // geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0], 3));
        // const pointMaterial = new PointsMaterial({
        //   color: 'yellow',
        //   size: 0.2,
        // });
        //  const po = new Points(geometry, pointMaterial);
        //  po.position.copy(p2);
        //  defect.clear();
        //  defect.add(po);
        return { x: Math.floor(p2.x / this.tileNum), y: Math.floor(p2.y / this.tileNum) };
    }

    getTilesByRect(points) {
        let result = [];
        let arr = [];
        for (let i = 1; i < points.length; i++) {
            const coor = new THREE.Vector2(points[i][0], points[i][1]);
            const tile = this.getTileByPoint(coor);
            arr.push(tile);
        }
        let xArr = arr.map(item => item.x).sort((a, b) => a - b);
        let yArr = arr.map(item => item.y).sort((a, b) => a - b);
        const minX = xArr[0];
        const minY = yArr[0];
        const maxX = xArr[xArr.length - 1];
        const maxY = yArr[yArr.length - 1];
        for (let i = minX; i < maxX + 1; i++) {
            for (let j = minY; j < maxY + 1; j++) {
                result.push({ x: i, y: j });
            }
        }
        return result;
    }
}